import React from "react";
import { Box, Grid, Typography, Card, CardContent } from "@mui/material";

const bankAccountsArray = [
  {
    imgSrc: `${process.env.PUBLIC_URL}/images/banks/barclays.png`,
    title: "Barclays",
    themeColor: "#00AEEF", // Barclays Blue
    description:
      "Enjoy simple and convenient banking with Barclays. No monthly fee for the first 12 months.",
    dimensions: { width: 80, height: 80 },
  },
  {
    imgSrc: `${process.env.PUBLIC_URL}/images/banks/hsbc.png`,
    title: "HSBC",
    themeColor: "#DB0011", // HSBC Red
    description:
      "HSBC offers a comprehensive business banking solution. No monthly fee for the first 18 months.",
    dimensions: { width: 80, height: 80 },
  },
  {
    imgSrc: `${process.env.PUBLIC_URL}/images/banks/lloyds.png`,
    title: "Lloyds Bank",
    themeColor: "#007B5F", // Lloyds Green
    description:
      "Lloyds Bank provides tailored banking services for your business. No monthly fee for the first 18 months.",
    dimensions: { width: 120, height: 80 },
  },
  {
    imgSrc: `${process.env.PUBLIC_URL}/images/banks/natwest.png`,
    title: "NatWest",
    themeColor: "#512D6D", // NatWest Purple
    description:
      "Manage your finances easily with NatWest's business accounts. Free banking for the first 18 months.",
    dimensions: { width: 80, height: 80 },
  },
  {
    imgSrc: `${process.env.PUBLIC_URL}/images/banks/monzo.png`,
    title: "Monzo",
    themeColor: "#EF483E", // Monzo Red
    description:
      "Monzo offers great flexibility and innovative banking features.",
    dimensions: { width: 100, height: 80 },
  },
  {
    imgSrc: `${process.env.PUBLIC_URL}/images/banks/revolut.png`,
    title: "Revolut",
    themeColor: "#0074E8", // Revolut Blue
    description:
      "Revolut provides powerful tools for managing your business finances.",
    dimensions: { width: 100, height: 80 },
  },
];

const BankAccounts = () => {
  return (
    <Box sx={{ pt: 4, pb: 4 }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        mb={0}
        sx={{ fontWeight: "bold" }}
      >
        Business Bank Accounts
      </Typography>
      <Typography variant="subtitle1" align="center" gutterBottom color="textSecondary">
        Form your company with us and choose your business bank account from a
        range of banks with no paperwork or stress.
      </Typography>
      <Grid container spacing={6} pt={3}>
        {bankAccountsArray.map((bankAccount, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                background: `linear-gradient(135deg, ${bankAccount.themeColor} 0%, #ffffff 100%)`,
                color: "#000",
                display: "flex",
                flexDirection: "column",
                alignItems: "left",
                textAlign: "left",
                borderRadius: "16px",
                boxShadow: 4,
                position: "relative",
                overflow: "hidden",
                padding: 2,
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundImage: "url('/path-to-pattern.png')", // Add a subtle pattern
                  opacity: 0.2,
                },
              }}
            >
              <Box
                sx={{
                  width: bankAccount.dimensions.width + 20,
                  height: bankAccount.dimensions.height + 20,
                  backgroundColor: "#ffffff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  marginBottom: 2,
                  zIndex: 2,
                }}
              >
                <img
                  src={bankAccount.imgSrc}
                  alt={bankAccount.title}
                  style={{
                    width: bankAccount.dimensions.width,
                    height: bankAccount.dimensions.height,
                    objectFit: "contain",
                  }}
                />
              </Box>
              <CardContent sx={{ zIndex: 1, p: 0 }}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "bold", marginBottom: 1 }}
                >
                  {bankAccount.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BankAccounts;
